import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
} from "@material-ui/core";
import Config from "Config";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

function TimeoutDialog(isOpen) {
    const { t, i18n } = useTranslation();
    const [open, setOpen] = useState(isOpen);
    const handleClose = () => {
        setOpen(false);
        if (
            navigator.userAgent.includes("iAM Smart In-App Browser") &&
            window.eIDJSBridge
        ) {
            window.eIDJSBridge.closeInAppBrowser();
        } else {
            window.location.replace(`${Config.CONTENT_PATH}/Login`);
        }
    };
    return (
        <React.Fragment>
            <Dialog aria-labelledby="simple-dialog-title" open={open}>
                <DialogContent style={{ textAlign: "center" }}>
                    {t(`common.portal.timeout`)}
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={handleClose} color="success">
                        <b>{t("common.portal.confirm")}</b>
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
export default TimeoutDialog;
